import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { useAuth } from '../hooks/useAuth';


export default function Odemeler() {
  const { profil } = useAuth();
  const navigate = useNavigate();
  const [siparisler, setSiparisler] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtre, setFiltre] = useState({ odeme_durumu: 'odenmedi', tarih_bas: '', tarih_bit: '', firma_id: '', temsilci_id: '' });
  const [firmalar, setFirmalar] = useState([]);
  const [temsilciler, setTemsilciler] = useState([]);
  const [toplam, setToplam] = useState(0);

  useEffect(() => { fetchData(); }, []);
  useEffect(() => { fetchSiparisler(); }, [filtre]);

  async function fetchData() {
    const [{ data: f }, { data: t }] = await Promise.all([
      supabase.from('firmalar').select('id, ad').eq('aktif', true),
      supabase.from('kullanicilar').select('id, ad, soyad').in('rol', ['temsilci', 'admin']).eq('aktif', true),
    ]);
    setFirmalar(f || []);
    setTemsilciler(t || []);
  }

  async function fetchSiparisler() {
    setLoading(true);
    let q = supabase.from('siparisler').select('*, musteriler(ad, sehir, telefon), firmalar(ad)').order('created_at', { ascending: false });
    if (profil?.rol === 'temsilci') q = q.eq('temsilci_id', profil.id);
    if (filtre.odeme_durumu) q = q.eq('odeme_durumu', filtre.odeme_durumu);
    if (filtre.firma_id) q = q.eq('firma_id', filtre.firma_id);
    if (filtre.temsilci_id) q = q.eq('temsilci_id', filtre.temsilci_id);
    if (filtre.tarih_bas) q = q.gte('created_at', filtre.tarih_bas);
    if (filtre.tarih_bit) q = q.lte('created_at', filtre.tarih_bit + 'T23:59:59');
    const { data } = await q;
    setSiparisler(data || []);
    setToplam((data || []).reduce((a, s) => a + (s.toplam_tutar || 0), 0));
    setLoading(false);
  }

  async function odemeAl(siparis) {
    const onay = window.confirm(
      `${siparis.siparis_no} siparişi için ödeme alındı mı?\n\n` +
      `⚠️ Ödeme kaydedildiğinde sipariş komisyona yansıyacaktır.\n` +
      `Dekont/makbuz için Sipariş Detayına gidin.`
    );
    if (!onay) return;
    await supabase.from('siparisler').update({ odeme_durumu: 'odendi' }).eq('id', siparis.id);
    await supabase.from('odeme_dekontlari').insert({
      siparis_id: siparis.id,
      tutar: siparis.toplam_tutar,
      odeme_turu: 'banka',
      not_: 'Ödemeler sayfasından manuel işlendi',
      created_by: profil?.id,
    });
    fetchSiparisler();
  }

  async function excelExport() {
    const XLSX = await import("xlsx");
    const rows = siparisler.map(s => ({ 'Sipariş No': s.siparis_no, 'Müşteri': s.musteriler?.ad, 'Şehir': s.musteriler?.sehir, 'Telefon': s.musteriler?.telefon, 'Firma': s.firmalar?.ad, 'Tutar': s.toplam_tutar, 'Ödeme Durumu': s.odeme_durumu, 'Tarih': new Date(s.created_at).toLocaleDateString('tr-TR') }));
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Ödemeler');
    XLSX.writeFile(wb, 'odemeler.xlsx');
  }

  function f(key, val) { setFiltre(p => ({ ...p, [key]: val })); }

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Ödemeler</h1>
          <p className="page-subtitle">{siparisler.length} sipariş • Toplam: {toplam.toLocaleString('tr-TR')} ₺</p>
        </div>
        <button className="btn btn-ghost btn-sm" onClick={excelExport}>📊 Excel</button>
      </div>

      <div className="filter-bar">
        <select className="select" value={filtre.odeme_durumu} onChange={e => f('odeme_durumu', e.target.value)}>
          <option value="">Tüm Ödemeler</option>
          <option value="odenmedi">Ödenmedi</option>
          <option value="odendi">Ödendi</option>
          <option value="kismi">Kısmi</option>
          <option value="vadeli">Vadeli</option>
        </select>
        <select className="select" value={filtre.firma_id} onChange={e => f('firma_id', e.target.value)}>
          <option value="">Tüm Firmalar</option>
          {firmalar.map(fi => <option key={fi.id} value={fi.id}>{fi.ad}</option>)}
        </select>
        {profil?.rol !== 'temsilci' && (
          <select className="select" value={filtre.temsilci_id} onChange={e => f('temsilci_id', e.target.value)}>
            <option value="">Tüm Temsilciler</option>
            {temsilciler.map(t => <option key={t.id} value={t.id}>{t.ad} {t.soyad}</option>)}
          </select>
        )}
        <input type="date" className="input" value={filtre.tarih_bas} onChange={e => f('tarih_bas', e.target.value)} />
        <input type="date" className="input" value={filtre.tarih_bit} onChange={e => f('tarih_bit', e.target.value)} />
        <button className="btn btn-ghost btn-sm" onClick={() => setFiltre({ odeme_durumu: '', tarih_bas: '', tarih_bit: '', firma_id: '', temsilci_id: '' })}>Temizle</button>
      </div>

      <div className="card" style={{ padding: 0 }}>
        <table className="table">
          <thead>
            <tr><th>Sipariş No</th><th>Müşteri</th><th>Şehir</th><th>Firma</th><th>Tutar</th><th>Ödeme</th><th>Tarih</th><th>İşlem</th></tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={8} className="loading">Yükleniyor...</td></tr>
            ) : siparisler.length === 0 ? (
              <tr><td colSpan={8} style={{ textAlign: 'center', padding: 40, color: 'var(--text2)' }}>Kayıt bulunamadı</td></tr>
            ) : siparisler.map(s => (
              <tr key={s.id}>
                <td><span className="mono" style={{ color: 'var(--accent)', cursor: 'pointer' }} onClick={() => navigate(`/siparisler/${s.id}`)}>{s.siparis_no}</span></td>
                <td style={{ fontWeight: 500 }}>{s.musteriler?.ad}</td>
                <td style={{ color: 'var(--text2)' }}>{s.musteriler?.sehir}</td>
                <td style={{ color: 'var(--text2)' }}>{s.firmalar?.ad}</td>
                <td style={{ fontWeight: 700 }}>{(s.toplam_tutar || 0).toLocaleString('tr-TR')} ₺</td>
                <td><span className={`badge ${s.odeme_durumu === 'odendi' ? 'badge-green' : s.odeme_durumu === 'kismi' ? 'badge-yellow' : 'badge-red'}`}>{s.odeme_durumu}</span></td>
                <td style={{ fontSize: 12, color: 'var(--text2)' }}>{new Date(s.created_at).toLocaleDateString('tr-TR')}</td>
                <td>
                  {s.odeme_durumu !== 'odendi' && profil?.rol !== 'temsilci' && (
                    <button className="btn btn-primary btn-sm" onClick={() => odemeAl(s)}>Ödeme Al</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
